var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7c7d7d}.cls-2{fill:#747575}.cls-3{fill:#dad7e5}.cls-4{fill:#edebf2}.cls-5{fill:#c6c3d8}.cls-6{fill:#ffba55}.cls-7{fill:#fc6}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The_Bees",
    "data-name": "The Bees"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26 10V4a3 3 0 0 1 6 0v1a1 1 0 0 1-2 0V4a1 1 0 0 0-2 0v6a1 1 0 0 1-2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20 10V4a1 1 0 0 0-2 0v1a1 1 0 0 1-2 0V4a3 3 0 0 1 6 0v6a1 1 0 0 1-2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27 17h-6a5 5 0 1 1 6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.57 15h-3.4a4.17 4.17 0 0 1-3.56-6.39A5 5 0 0 1 28.57 15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24 17c-6.49 8.43-7.39 10.18-10.62 11.74s-7.53 2-10.33-.79C-1.11 23.79 1.46 17 7 17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24 17c-5.71 7.43-8.12 12.05-14.34 12.88C3.92 28.83 2 21.44 6.35 18.2 8.6 16.51 9.48 17 24 17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.3 40.17-.83 1.37c-4.25 7.28-.69 7.28-4.94 0l-.83-1.37a7 7 0 0 0 6.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24 17c-6.58 15.93-6.17 16.11-8.25 16.8a3.57 3.57 0 0 1-3.7-.85A4.06 4.06 0 0 1 11 29.62C16.21 28.3 17.81 25 24 17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24 17c-2.7 6.54-1.7 4.73-4.39 8.24A12.22 12.22 0 0 1 11 30c0-.71-.14.05 2.38-1.21C16.69 27.14 17.65 25.26 24 17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.53 28h-9.06L24 17l4.53 11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.25 33.8c-.09.3 1.16.2-16.43.2a1.18 1.18 0 0 1-.07-.2c2-.67 2.32-2.4 3.72-5.8h9.06c1.47 3.56 1.74 5.15 3.72 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.62 28.74C31.31 27.14 30.35 25.26 24 17c18.38 0 18.49-.38 20.6 1.2 5.88 4.33.4 15.72-9.98 10.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37 29.62A4 4 0 0 1 36 33a3.57 3.57 0 0 1-3.7.85c-2-.67-1.58-.63-8.25-16.8 6.28 8.18 7.83 11.27 12.95 12.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37 29.62V30a12.19 12.19 0 0 1-8.61-4.71C25.69 21.73 26.7 23.55 24 17c6.05 7.86 7.74 11.29 13 12.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.18 34C29 43.29 19 43.36 15.82 34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24 41a7.33 7.33 0 0 1-3.3-.83A30 30 0 0 1 24 47c.29-.87.63-1.73 1-2.57-1.76-4-1.88-1.6 1.47-2.89 1.7-2.73.81-.54-2.47-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.8 35a11.59 11.59 0 0 1-2.34 3.56C25.64 40 21.79 37.9 19.69 34h9.24a3.63 3.63 0 0 0 2.87 1zM26.12 28h-6.65l3.33-8.07c1.83 4.43 1.07 2.6 3.32 8.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.93 34h-9.24a14.24 14.24 0 0 1-1.28-3.43L19.47 28h6.65c2.03 4.94 2.06 5.31 2.81 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBee);
export default __webpack_public_path__ + "static/media/bee.1d47c4587e179ce5fc1b5a8ae0dcacf0.svg";
export { ForwardRef as ReactComponent };